"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../../api/webAApi");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var moment = require("moment");
var AffilatesEMailSetTemplateImagesListCtl = /** @class */ (function (_super) {
    __extends(AffilatesEMailSetTemplateImagesListCtl, _super);
    function AffilatesEMailSetTemplateImagesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_email_set_template_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.email_set_template_id; });
        _this.dk_email_set_template_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.email_set_template_title; });
        _this.dk_image_identity = UIUtils_1.UIUtils.IProp2Str(function (o) { o.image_identity; });
        _this.dk_image_url = UIUtils_1.UIUtils.IProp2Str(function (o) { o.image_url; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this._errDialog = errDialog;
        return _this;
    }
    AffilatesEMailSetTemplateImagesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0,
            cdn_baseurl: ""
        };
    };
    AffilatesEMailSetTemplateImagesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    AffilatesEMailSetTemplateImagesListCtl.prototype.LoadData = function (Key, onDone) {
        var _this = this;
        webAApi_1.ListPProgramEmailSetTemplateImagesGet.exec({ email_set_template_id: Key }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            _this.DATA.cdn_baseurl = resp.cdn_baseurl;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    email_set_template_id: resp.list[i].email_set_template_id,
                    email_set_template_title: resp.list[i].email_set_template_title,
                    description: resp.list[i].description,
                    image_identity: resp.list[i].image_identity,
                    image_url: resp.list[i].image_url,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AffilatesEMailSetTemplateImagesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddPProgramEmailSetTemplateImage.exec({
            data: {
                email_set_template_id: data.email_set_template_id,
                image_identity: data.image_identity,
                image_url: data.image_url,
                description: data.description,
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_added: moment(resp.date_added_uts_ms).utc(false),
                date_changed: moment(resp.date_added_uts_ms).utc(false),
                email_set_template_id: data.email_set_template_id,
                description: data.description,
                email_set_template_title: resp.email_set_template_title,
                image_identity: data.image_identity,
                image_url: data.image_url
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AffilatesEMailSetTemplateImagesListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditPProgramEmailSetTemplateImage.exec({
                data: {
                    email_set_template_image_id: data.key,
                    image_identity: data.image_identity,
                    image_url: data.image_url,
                    description: data.description
                }
            }, function (resp) {
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.image_identity = data.image_identity;
                _tmp.image_url = data.image_url;
                _tmp.description = data.description;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    AffilatesEMailSetTemplateImagesListCtl.prototype.DeleteData = function (GwsEmailSetTemplateImageId, onDone) {
        var _this = this;
        var _tmp = this.getById(GwsEmailSetTemplateImageId);
        if (_tmp) {
            webAApi_1.DoDeletePProgramEmailSetTemplateImage.exec({
                data: {
                    email_set_template_image_id: GwsEmailSetTemplateImageId
                }
            }, function (resp) {
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return AffilatesEMailSetTemplateImagesListCtl;
}(BaseController_1.BaseController));
exports.AffilatesEMailSetTemplateImagesListCtl = AffilatesEMailSetTemplateImagesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ctl/options/AffilatesEmailSetTemplateImageListCtl.ts
// module id = 1006
// module chunks = 0